import { Component, ElementRef, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import getFormat from './config';

declare var jQuery: any;

@Component({
  selector: 'ch-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.css'],
})
export class DatepickerComponent implements OnInit {
  @Input() public date: string;
  @Input() public datetime: boolean;
  @Input() public monthOnly: boolean;
  @Input() public minDate: string;
  @Output() public onChange: EventEmitter<any> = new EventEmitter();
  public value: string;
  private dateFormat: string = 'DD/MM/YYYY';

  constructor() { }

  ngOnInit() {
    this.dateFormat = getFormat(this.datetime, this.monthOnly);
  }

  public change(value) {
    this.onChange.emit(value);
  }

  ngOnChanges() {
    // Ensure dateFormat is set before formatting
    this.dateFormat = getFormat(this.datetime, this.monthOnly);

    if (this.date && !isNaN(new Date(this.date).getTime())) {
      this.value = moment(this.date).format(this.dateFormat);
    } else {
      this.value = null;
    }
  }

  getMinDateIfPresent(): string {
    if (this.minDate) {
      const parsed = moment(this.minDate);
      return parsed && parsed.isValid() ? this.minDate : null
    }
    return null;
  }

  public clear() {
    this.value = null;
    this.change(null);
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/core/datepicker/datepicker.component.ts